import React from 'react';
import { Flex, IconButton, Input } from '@chakra-ui/react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import { shiftMonth } from '../format';

interface MonthSelectorProps {
  value: string; // AAAA-MM
  onChange: (month: string) => void;
  label?: string;
}

export const MonthSelector: React.FC<MonthSelectorProps> = ({
  value,
  onChange,
  label = 'Mês das análises',
}) => (
  <Flex gridGap="2" align="center">
    <IconButton
      aria-label="Mês anterior"
      icon={<FiChevronLeft />}
      size="sm"
      onClick={() => onChange(shiftMonth(value, -1))}
    />
    <Input
      type="month"
      size="sm"
      w="170px"
      value={value}
      aria-label={label}
      onChange={event => event.target.value && onChange(event.target.value)}
    />
    <IconButton
      aria-label="Próximo mês"
      icon={<FiChevronRight />}
      size="sm"
      onClick={() => onChange(shiftMonth(value, 1))}
    />
  </Flex>
);
